import { PrincipleListResponse, PrincipleQueryParams } from "../types"

export class Principle {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }

  list(
    vendorId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<PrincipleListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/search-principal`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  filter(
    vendorId: string,
    body?: PrincipleQueryParams,
    query?: PrincipleQueryParams,
    headers?: Record<string, unknown>
  ): Promise<PrincipleListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/search-principal`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }
}
